module.exports = __webpack_public_path__ + "img/ico_contatos.17472a8b.svg";